import {useState} from "react";
import {useTranslation} from 'react-i18next';
import {useSnackbar} from 'notistack';
import {LessonFormValidationErrors} from "models/LessonFormValidationErrors";
import {LessonForm} from "components/views/editor/models/LessonForm";

const requiredImgHeight = 180;
const requiredImgWidth = 320;

export const useLessonFormValidator = () => {
    const [errors, setErrors] = useState<LessonFormValidationErrors>({} as LessonFormValidationErrors);
    const {t} = useTranslation();
    const { enqueueSnackbar } = useSnackbar();

    const isValid = (lessonForm: LessonForm): boolean => {

        let formErrors: LessonFormValidationErrors = {} as LessonFormValidationErrors;

        if (lessonForm.lessonName.length < 5) {
            formErrors.lessonName = t("lessonEditor.formValidationError.lessonNameToShort");
        }

        if (lessonForm.lessonVersionName.length < 5) {
            formErrors.lessonVersionName = t("lessonEditor.formValidationError.versionNameToShort");
        }

        if (lessonForm.image && !(lessonForm.image.height === requiredImgHeight && lessonForm.image.width === requiredImgWidth)) {
            formErrors.image = t("lessonEditor.formValidationError.imageWrongRes", {
                width: requiredImgWidth,
                height: requiredImgHeight
            });
        }

        if (lessonForm.maxPoints <= 0) {
            formErrors.maxPoints = t("lessonEditor.formValidationError.totalScoreToLow");
        }

        setErrors(formErrors);

        if (Object.keys(formErrors).length !== 0) {
            enqueueSnackbar(t("lessonEditor.errorFixFormIssues"), {
                anchorOrigin: {vertical: 'bottom', horizontal: 'center'},
                variant: 'error'
            });
        }

        return Object.keys(formErrors).length === 0;
    }

    const reset = (fields: (keyof LessonForm)[] = []) => {
        if (fields.length === 0) {
            setErrors({});
            return;
        }

        let updatedErrors = errors;
        fields.forEach(field => {
            delete updatedErrors[field];
        });
        setErrors(updatedErrors);
    }


    return {isValid, reset, errors};
}